import React, { useState, useEffect } from 'react'
import { getAllRooms, leaveRoom, deleteRoom,
manageSocialRoom, getAllRoomsFilter } from '../../actions/userActions';
import { connect } from 'react-redux'
import { UseComponentVisible2 } from '../../containers/UseComponentVisible2'
import { seeListChatCategories } from '../../admin/actions/categoriesActions'
import { Translate } from '../../language';
import Modal from '../../containers/Modal';
import circle from '../../img/circulogris.png';
import searchIcon from '../../img/ic__buscador.png'
import inMemoryJWT from '../../auth/inMemoryJwt'
import localStorage from '../../utils/hooks/useLocalStorage';


const SeeAllRooms = ({ location, match, allRooms, seeListChatCategories, isLoadingAllRooms, getAllRooms, isLoadingListChatCategories, listChatCategories, leaveRoom, manageSocialRoom, getAllRoomsFilter, deleteRoom, history }) => {
    console.log()
    const [categorieID, setCategorieID] = useState('')
    const [categorie, setCategorie] = useState('')
    const [isShowModal, setIsShowModal] = useState(false)
    const [isValidate, setValidate] = useState(false)
    const [isAcceptTerms, setIsAcceptTerms] = useState(false)
    const [roomRules, setRoomRules] = useState(false)
    const [idRoomView, setIdRoomView] = useState('')
    const [error, setError] = useState({})

    const selectModal = (e) => {
        setIsShowModal(!isShowModal)
    }

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getAllRoomsFilter({ categoryID: match.params.categoryName, search: "" })
            seeListChatCategories()
        })

    }, [match.params.categoryName])

    const {
        ref2,
        isComponentVisible2,
        setIsComponentVisible2
    } = UseComponentVisible2(false);
    console.log()
    const isChecked = () => {
        setIsAcceptTerms(!isAcceptTerms)


        if (!isAcceptTerms) {
            setValidate(true)
            setError(prevError => ({
                ...prevError,
                [checkTermsOfServiceVar]: ''
            }));
        }

        var checkTermsOfServiceVar = 'checkTermsOfService'

        if (isAcceptTerms) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [checkTermsOfServiceVar]: Translate('isAcceptTerms', 'es')
            })); 
        }
    }
    return (
        <div className="container-community-by-category">
            <div className='title-admin centerItems mb-4'>{listChatCategories.find(category =>category._id ===match.params.categoryName)?.name}</div>
            <div className="search-bar-navbar search-bar-navbar-community-by-category">
                <input
                    autoComplete="off"
                    className="input-inside-div"
                    name="categorie"
                    type="text"
                    value={categorie}
                    onChange={(e) => {
                        setCategorie(e.target.value)
                    }}
                />
                <img src={searchIcon} alt="img" className="img-search-bar-right" />
            </div>
            <div className='wrapper-6 parent-width column-gap centerItems centerContent mt-5'>
                {isLoadingAllRooms ? <div>Cargando...</div> :
                    allRooms.map((room, index) =>
                        room.name.toUpperCase().includes(categorie.toUpperCase()) &&
                        <div onClick={(e) => {
                            console.log()
                            setIdRoomView(room._id)
                            selectModal(e)
                            setRoomRules(room.rules)
                        }} className="card-rooms-view">
                            <div className="community-img-card-category">
                                <img src={room.profilePicture ? room.profilePicture.url.origin : circle} alt="img" className="community-img-card-category" />
                            </div>
                            <div onClick={(e) => {

                            }} className="column centerItems pointer">                               
                                <div className="">@{room.name}</div>
                            </div>
                            <div className="btns-card-room">Ingresar</div>
                            <Modal
                                displayModal={isShowModal}
                                closeModal={selectModal}
                                content={<div className="rules-room-modal"> Normas:  {roomRules}
                                    <div className="column centerItems">
                                        <input
                                            name="checkTermsOfService"
                                            onClick={() => isChecked()}
                                            type="checkbox"
                                        />
                                        <div className="textBlack littleText" htmlFor="checkTermsOfService">
                                            Acepto las normas de la sala
                                        </div>
                                    </div>
                                    <div className="text-error">{error.checkTermsOfService}</div>
                                    <button disabled={isValidate ? '' : 'disabled'}
                                        className={isValidate ? "btn btn-purple" : 'btn btn-inactive'} onClick={() => {
                                            manageSocialRoom({
                                                chatID: idRoomView,
                                                entityID: localStorage().getItem('idProfile'),
                                                adminID: room.adminID,
                                                type: 0
                                            })
                                        }} >Ingresar</button>
                                </div>}
                                typeModal='modal-access-room'
                            />
                        </div>
                    )
                }
            </div>
        </div>




    )
}
const mapStateToProps = (state) => {
    return {
        isLoadingAllRooms: state.userInfo.isLoadingAllRooms,
        allRooms: state.userInfo.allRoomsFilter,
        isLoadingListChatCategories: state.socialCategoriesAdmin.isLoadingListChatCategories,
        listChatCategories: state.socialCategoriesAdmin.listChatCategories,
    }
}
export default connect(mapStateToProps, { getAllRooms, leaveRoom, deleteRoom, manageSocialRoom, getAllRoomsFilter, seeListChatCategories })(SeeAllRooms)
